import React, { useState, useEffect } from "react";
import { Button, FormGroup, Label, Input } from "reactstrap";
import Cookies from "js-cookie";
import { useHistory, useLocation } from "react-router-dom";
import ApiCaller from "../../api/apiCaller";
import ModalTwoFactor from "./ModalTwoFactor";
import HRWConstant from 'constants/hrw';

import "./index.css";

interface UserValueProps {
  property: string;
  value: any;
}

export default function Login() {
  const history = useHistory();
  const search = window.location.search;
  const searchParams = new URLSearchParams(search);
  const redirectTo = searchParams.get('redirect_to');
  
  const [twoFactorDialog, setTwoFactorDialog] = useState(false);
  const [twoFaUserId, setTwoFaUserId] = useState(0);
  const [user, setUser] = useState({
    username: "",
    password: "",
    provider: "db",
    refresh: true,
  });
  const handleLoginData = async (res: any) => {
    await Cookies.set("access_token", res?.access_token, {
      expires: 7,
      secure: process.env.NODE_ENV === 'production',
      sameSite: process.env.NODE_ENV === 'production' ? 'none' : 'lax',
      path: '/',
    });
    await Cookies.set("refresh_token", res?.refresh_token, {
      expires: 7,
      secure: process.env.NODE_ENV === 'production',
      sameSite: process.env.NODE_ENV === 'production' ? 'none' : 'lax',
      path: '/',
    });
    if (redirectTo) {
      history.push(redirectTo);
    } else {
      history.push("/");
    }
    window.location.reload();
    const userRes = await ApiCaller.get("userme/me");
    if (userRes?.result) {
      await Cookies.set("email", userRes?.result?.email, {
        expires: 7,
        secure: process.env.NODE_ENV === 'production',
        sameSite: process.env.NODE_ENV === 'production' ? 'none' : 'lax',
        path: '/',
      });
      await Cookies.set("first_name", userRes?.result?.first_name, {
        expires: 7,
        secure: process.env.NODE_ENV === 'production',
        sameSite: process.env.NODE_ENV === 'production' ? 'none' : 'lax',
        path: '/',
      });
      await Cookies.set("current_user_id", userRes?.result?.id, {
        expires: 7,
        secure: process.env.NODE_ENV === 'production',
        sameSite: process.env.NODE_ENV === 'production' ? 'none' : 'lax',
        path: '/',
      });
      if (redirectTo) {
        history.push(redirectTo);
      } else {
        history.push("/");
      }
      window.location.reload();
    }
  };
  const login = async () => {
    const res = await ApiCaller.post("user/login", user);
    if (res?.access_token) {
      handleLoginData(res);
    } else if (res?.statusCode == 202) {
      setTwoFaUserId(res.user_id);
      setTwoFactorDialog(true);
    } else {
      alert(`Login failure. ${res.message || res.msg}`);
    }
  };
  const loginWithHRV = () => {
    let authUrl = 'https://accounts.haravan.com/connect/authorize?';
    authUrl += `response_mode=${HRWConstant.responseMode}&response_type=${HRWConstant.responseType}`;
    authUrl += `&scope=${HRWConstant.scope_string}&client_id=${HRWConstant.clientId}`;
    authUrl += `&redirect_uri=${HRWConstant.redirectUri}&nonce=12frg5`;
    console.log(authUrl);
    window.location.href = authUrl;
  };
  const editUserValue = ({ property, value }: UserValueProps) => {
    setUser({ ...user, ...{ [property]: value } });
  };
  const toggle = () =>
    setTwoFactorDialog((twoFactorDialog) => !twoFactorDialog);
  useEffect(() => {
    const access_token = searchParams.get('access_token');
    const refresh_token = searchParams.get('refresh_token');
    if (access_token) {
      handleLoginData({ access_token, refresh_token, redirectTo });
    }
  }, [searchParams]);
  return (
    <div className="main-login-form">
      <FormGroup>
        <Label>Username</Label>
        <Input
          value={user?.username}
          type="email"
          placeholder="hello@lisa.vn"
          onChange={(e) =>
            editUserValue({ property: "username", value: e.target.value })
          }
        />
      </FormGroup>
      <FormGroup>
        <Label>Password</Label>
        <Input
          value={user?.password}
          type="password"
          placeholder="Password"
          onChange={(e) =>
            editUserValue({ property: "password", value: e.target.value })
          }
        />
      </FormGroup>
      <FormGroup>
        <Label />
        <Button block color="primary" onClick={login}>
          Login
        </Button>
      </FormGroup>
      <FormGroup>
        <Label />
        <Button block color="info" onClick={loginWithHRV}>
          Login using HRV account
        </Button>
      </FormGroup>
      <ModalTwoFactor
        handleLogin={handleLoginData}
        isOpen={twoFactorDialog}
        toggle={toggle}
        userId={twoFaUserId}
      />
    </div>
  );
}
